import axios from "axios";
import {message} from "antd";

import {memoizedRefreshToken} from "./refreshToken";

const axiosConfig = {
	baseURL: process.env.REACT_APP_SERVICE_URL,
	headers: {
		'Content-Type': 'application/json',
	}
}

const request = axios.create(axiosConfig)

// Các endpoint xác thực: 401/422 ở đây là lỗi đăng nhập thật (sai mật khẩu,
// refresh token hết hạn...) chứ KHÔNG phải access token hết hạn → không refresh.
const AUTH_ENDPOINTS = ['auth/login', 'auth/register', 'auth/refresh', 'auth/google'];

const isAuthEndpoint = (url = '') => AUTH_ENDPOINTS.some((path) => url.includes(path));

request.interceptors.request.use(
	async (config) => {

		const storedToken = JSON.parse(localStorage.getItem('access_token'));

		const loginAsToken = localStorage.getItem('access_token_as');

		if (storedToken?.accessToken) {
			config.headers = {
				...config.headers,
				"Authorization": `Bearer ${storedToken.accessToken}`,
			};

			// Chỉ gửi khi đang mạo danh — tránh gửi chuỗi "null" làm header rác.
			if (loginAsToken) {
				config.headers.loginAsToken = loginAsToken;
			} else {
				delete config.headers.loginAsToken;
			}
		}

		return config;
	},
	(error) => Promise.reject(error)
);

request.interceptors.response.use(
	(response) => response.data,
	async (error) => {
		const config = error?.config;

		// 402 = hết hạn mức gói (PlanLimit). Nhắc nâng cấp toàn cục (toast trên cùng),
		// độc lập với xử lý lỗi tại từng màn. Dùng key cố định để không chồng toast.
		if (error?.response?.status === 402) {
			const body = error?.response?.data;
			message.warning({
				key: 'plan-limit',
				content: body?.message || 'Bạn đã đạt giới hạn của gói. Vui lòng nâng cấp.',
				duration: 4,
			});
		}

		const storedToken = JSON.parse(localStorage.getItem('access_token') || 'null');

		// Chỉ thử refresh khi: lỗi 401, chưa retry, KHÔNG phải endpoint auth, và
		// đang thực sự có access token (tức request của người đã đăng nhập bị hết hạn).
		const shouldRefresh = error?.response?.status === 401
			&& !config?.sent
			&& !isAuthEndpoint(config?.url || '')
			&& Boolean(storedToken?.accessToken);

		if (shouldRefresh) {

			config.sent = true;

			const result = await memoizedRefreshToken();

			// Chỉ retry request gốc khi refresh THÀNH CÔNG. Nếu thất bại thì dừng
			// (refreshToken đã clear localStorage) và trả lỗi về cho caller.
			if (result?.accessToken) {
				config.headers = {
					...config.headers,
					Authorization: `Bearer ${result.accessToken}`,
				};

				return request(config);
			}
		}

		return Promise.reject(error);
	}
);


export default request;